export default function PHP_implode() {
  return (
    <div>
      <h1>PHP_implode</h1>
    </div>
  );
}
